import React from "react";
import cx from "classnames";
import get from "lodash/get";
import PropTypes from "prop-types";

import TitledContainer, { StaticText } from "components/TitledContainer";

import styles from "forms/forms.css";

const RenderField = (props) => {
  const {
    after,
    autoComplete = "off",
    autoFocus,
    before,
    field,
    form,
    isEdit,
    label,
    onEdit,
    placeholder,
    type,
    ...rest
  } = props;

  return (
    <div className={styles.field} {...rest}>
      {before && <span className={styles.before}>{before}</span>}
      <TitledContainer
        isEdit={isEdit}
        isEmpty={!field.value}
        onEdit={onEdit}
        title={label}
        isEditable
      >
        {!isEdit && <StaticText text={field.value} />}
        {isEdit && (
          <input
            {...field}
            {...(autoFocus && { autoFocus })}
            autoComplete={autoComplete}
            className={cx({
              [styles.error]: !!form.submitCount && get(form.errors, field.name, false),
            })}
            placeholder={placeholder}
            type={type}
          />
        )}
      </TitledContainer>
      {after && <span className={styles.after}>{after}</span>}
    </div>
  );
};

RenderField.propTypes = {
  autoComplete: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
  }),
  form: PropTypes.object, // eslint-disable-line
  after: PropTypes.string,
  before: PropTypes.string,
  isEdit: PropTypes.bool,
  label: PropTypes.string,
  onEdit: PropTypes.func,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
};

RenderField.defaultProps = {
  isEdit: true,
};

export default RenderField;
